/* Plasmito: next Rip & Ship from the public Twitch schedule (iCalendar). See snippets/pl-twitch-schedule.liquid */
(() => {
  const cfg = window.plTwitchSchedule;
  if (!cfg || !window.fetch) return;

  const CACHE_KEY = 'pl_twitch_schedule';
  const CACHE_TTL = 10 * 60 * 1000;

  // Offset (ms) of `timeZone` at instant `date`.
  const tzOffset = (date, timeZone) => {
    const parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
      .formatToParts(date)
      .forEach((p) => (parts[p.type] = p.value));
    const asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
    return asUtc - date.getTime();
  };

  // "20261023T160000" (+ optional Z) in time zone `tz` -> Date
  const parseIcsDate = (value, tz) => {
    const m = /^(\d{4})(\d{2})(\d{2})(?:T(\d{2})(\d{2})(\d{2})?)?(Z)?$/.exec(value.trim());
    if (!m) return null;
    const wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
    if (m[7] || !tz) return new Date(wall);
    try {
      let utc = wall - tzOffset(new Date(wall), tz);
      utc = wall - tzOffset(new Date(utc), tz);
      return new Date(utc);
    } catch (e) {
      return new Date(wall);
    }
  };

  const parseIcs = (text) => {
    const lines = text.replace(/\r\n[ \t]/g, '').split(/\r?\n/);
    const events = [];
    let ev = null;
    lines.forEach((line) => {
      if (line === 'BEGIN:VEVENT') ev = {};
      else if (line === 'END:VEVENT') {
        if (ev && ev.start) events.push(ev);
        ev = null;
      } else if (ev) {
        const idx = line.indexOf(':');
        if (idx < 0) return;
        const head = line.slice(0, idx);
        const value = line.slice(idx + 1);
        const [name, ...params] = head.split(';');
        const tzParam = params.find((p) => p.startsWith('TZID='));
        const tz = tzParam ? tzParam.slice(5).replace(/^\//, '') : null;
        if (name === 'DTSTART') ev.start = parseIcsDate(value, tz);
        else if (name === 'DTEND') ev.end = parseIcsDate(value, tz);
        else if (name === 'SUMMARY') ev.title = value.replace(/\\,/g, ',').replace(/\\;/g, ';');
        else if (name === 'RRULE') ev.rrule = value;
      }
    });
    return events;
  };

  // Next occurrence (start/end) of an event ending after `now`. Supports simple WEEKLY/DAILY rules.
  const nextOccurrence = (ev, now) => {
    const duration = (ev.end ? ev.end - ev.start : 2 * 3600 * 1000) || 0;
    let start = ev.start.getTime();
    if (ev.rrule) {
      const rule = Object.fromEntries(ev.rrule.split(';').map((kv) => kv.split('=')));
      const interval = +(rule.INTERVAL || 1);
      const step = rule.FREQ === 'DAILY' ? 864e5 * interval : rule.FREQ === 'WEEKLY' ? 7 * 864e5 * interval : 0;
      const until = rule.UNTIL ? parseIcsDate(rule.UNTIL, null) : null;
      if (step && start + duration < now) {
        start += Math.ceil((now - duration - start) / step) * step;
      }
      if (until && start > until.getTime()) return null;
    }
    if (start + duration < now) return null;
    return { start: new Date(start), end: new Date(start + duration), title: ev.title || '' };
  };

  const pickNext = (events) => {
    const now = Date.now();
    const kw = (cfg.keyword || '').trim().toLowerCase();
    return events
      .filter((ev) => !kw || (ev.title || '').toLowerCase().includes(kw))
      .map((ev) => nextOccurrence(ev, now))
      .filter(Boolean)
      .sort((a, b) => a.start - b.start)[0];
  };

  const formatDate = (date) => {
    try {
      return new Intl.DateTimeFormat(cfg.locale || undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
      }).format(date);
    } catch (e) {
      return date.toLocaleString();
    }
  };

  // Translations arrive HTML-escaped (e.g. "Rip &amp; Ship"); decode for textContent.
  const decode = (s) => {
    const t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  };

  const setText = (el, text) => {
    const target = el.querySelector('a') || el;
    target.textContent = text;
  };

  const apply = (next) => {
    const now = Date.now();
    const isLive = !!next && next.start.getTime() <= now && now < next.end.getTime();
    document.querySelectorAll('[data-pl-live-badge]').forEach((b) => (b.hidden = !isLive));
    let text;
    if (!next) text = decode(cfg.labels.none);
    else if (isLive) text = decode(cfg.labels.live);
    else text = decode(cfg.labels.next).replace('%DATE%', formatDate(next.start));
    document.querySelectorAll('[data-pl-schedule-target]').forEach((el) => setText(el, text));
  };

  const readCache = () => {
    try {
      // A page reload (F5 / Ctrl+F5) always refetches the schedule.
      const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'reload') return null;
      const c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.url === cfg.url && Date.now() - c.at < CACHE_TTL) return c.text;
    } catch (e) {}
    return null;
  };
  const writeCache = (text) => {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ url: cfg.url, at: Date.now(), text }));
    } catch (e) {}
  };

  const run = (text) => {
    let next = null;
    try {
      next = pickNext(parseIcs(text));
    } catch (e) {}
    apply(next);
    // Re-evaluate when the segment starts or ends while the page stays open.
    if (next) {
      const now = Date.now();
      const at = next.start.getTime() > now ? next.start.getTime() : next.end.getTime();
      const wait = at - now + 1000;
      if (wait > 0 && wait < 2 ** 31 - 1) setTimeout(() => run(text), wait);
    }
  };

  const cached = readCache();
  if (cached) {
    run(cached);
    return;
  }
  fetch(cfg.url, { headers: { Accept: 'text/calendar' } })
    .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
    .then((text) => {
      writeCache(text);
      run(text);
    })
    .catch(() => apply(null));
})();
